<template>
    <div>
        <UserNavigation/>
        <h1>Kontakt</h1>
    </div>
</template>

<script>
import UserNavigation from '../UserNavigation'

export default {
    name: 'Contact',
    components: {
        UserNavigation
    }
}
</script>

<style scoped>
* {
    background: #F0EAD6;
}

</style>